module.exports = __webpack_public_path__ + "img/高风险.e9b11089.png";